export default "__VITE_ASSET__BqjdyjY2__"